import { ApiResponse } from '@/shared/types';
import { axiosClient } from '@/shared/apis/config';
import { useQuery } from '@tanstack/react-query';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { z } from 'zod';
import { DtoBrandTemplateStatus } from '@/shared/constants';
import { brandTemplateSchema } from '@/features/brand-template/model/brand-template';

export const GetBrandTemplateResponseSchema = z.object({
  id: z.number(),
  tenantId: z.number(),
  creatorAccountId: z.number(),
  payload: brandTemplateSchema,
  brandTemplateStatus: z.nativeEnum(DtoBrandTemplateStatus),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type GetBrandTemplateResponse = z.infer<
  typeof GetBrandTemplateResponseSchema
>;

export type response = ApiResponse<GetBrandTemplateResponse>;

export const getBrandTemplateApi = async (id: number) => {
  try {
    const response = await axiosClient.get<response>(
      `/v1.0/brand-template/${id}`,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetBrandTemplateApi =
  'queryKeyUseGetBrandTemplateApi' as const;

export const useGetBrandTemplateApi = ({
  id,
  options,
}: {
  id?: number | null;
  options?: CustomQueryOptions<response>;
}) => {
  const { queryKey, ...rest } = options ?? {};

  return useQuery({
    queryKey: [QueryKeyUseGetBrandTemplateApi, id, queryKey],
    queryFn: async () => await getBrandTemplateApi(id!),
    enabled: !!id,
    ...rest,
  });
};
